<button
  type="button"
  class="image-lightbox-trigger"
  (click)="open()"
  [attr.aria-label]="'Ingrandisci ' + alt"
>
  <img [src]="src" [alt]="alt" class="app-content-image">
  <span class="image-lightbox-hint" aria-hidden="true">
    <i class="bi bi-zoom-in"></i>
  </span>
</button>

@if (isOpen()) {
  <div
    class="image-lightbox"
    data-testid="image-lightbox"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="alt"
    (click)="close()"
  >
    <div class="image-lightbox-toolbar" (click)="$event.stopPropagation()">
      <button type="button" class="btn btn-outline-light btn-sm" (click)="zoomOut()" aria-label="Riduci">
        <i class="bi bi-zoom-out"></i>
      </button>
      <button type="button" class="btn btn-outline-light btn-sm" (click)="zoomIn()" aria-label="Ingrandisci">
        <i class="bi bi-zoom-in"></i>
      </button>
      <button
        #closeBtn
        type="button"
        class="btn btn-outline-light btn-sm"
        data-testid="image-lightbox-close"
        (click)="close()"
        aria-label="Chiudi"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <img
      class="image-lightbox-image"
      [src]="src"
      [alt]="alt"
      [style.transform]="imageTransform()"
      (click)="onImageClick($event)"
      (pointerdown)="onPointerDown($event)"
    >
  </div>
}
